import type { FC, ReactNode } from 'react';
import React, { useState, useCallback } from 'react';

import styles from './Tooltip.module.scss';

export type TooltipProps = {
  content: ReactNode;
  children: ReactNode;
  disabled?: boolean;
};

export const Tooltip: FC<TooltipProps> = ({ content, children, disabled }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = useCallback(() => {
    if (disabled) {
      return;
    }
    setIsVisible(true);
  }, [disabled]);

  const hideTooltip = useCallback(() => {
    if (disabled) {
      return;
    }
    setIsVisible(false);
  }, [disabled]);

  const handleMouseEnter = useCallback(() => {
    showTooltip();
  }, [showTooltip]);

  const handleMouseLeave = useCallback(() => {
    hideTooltip();
  }, [hideTooltip]);

  const handleFocus = useCallback(() => {
    showTooltip();
  }, [showTooltip]);

  const handleBlur = useCallback(() => {
    hideTooltip();
  }, [hideTooltip]);

  return (
    <div
      className={styles.tooltipContainer}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      {children}
      {isVisible && !disabled && (
        <div className={styles.tooltip} role="tooltip">
          <div className={styles.tooltipContent}>{content}</div>
        </div>
      )}
    </div>
  );
};
